module.exports = __webpack_public_path__ + "static/media/SUSHI-ETH.1cc34dea.svg";